import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { Project } from '../../../utils/models';

import 'swiper/css';

import DashboardRecentProject from '../../pages/dashboard/dashboardRecentProject';
import DBEmptyData from '../../pages/dashboard/dashboardEmptyData';

import classNames from './style.module.scss';

interface RecentProjectsProps {
	recentProjects: Project[];
}

const RecentProjects = (props: RecentProjectsProps) => {
	return (
		<Swiper
			modules={[Autoplay]}
			autoplay={{ delay: 2500 }}
			spaceBetween={20}
			slidesPerView={3}
			className={classNames.recentProjects}
		>
			{props.recentProjects.length > 0 ? (
				props.recentProjects.map((recentProject) => (
					<SwiperSlide key={recentProject.documentNumber}>
						<DashboardRecentProject project={recentProject} />
					</SwiperSlide>
				))
			) : (
				<DBEmptyData isVisible message="No recent projects yet" />
			)}
		</Swiper>
	);
};

export default RecentProjects;
